<!--<div class="document-container">-->
<div style="min-height: 100vh; height: auto; overflow: visible; position: relative">
  @for (page of pages; track $index; let i = $index; let last = $last) {
    <div class="page">
      <div class="black-stripe"></div>
      <!-- Encabezado Fijo -->
      <div class="header flex flex-center-between">
        <div>
          <h1 class="text-header-16 text-semibold">{{ isInvoiceOrder ? 'Estado de pago: ' : 'Orden de compra: ' }}<span
            style="color: #0072F5">#{{ order.reference }}</span></h1>
        </div>
        <div>
          <img class="svg-container" [src]="environment.baseUrl + '/assets/images/image_20.png'" (load)="onLogoLoaded()"
               width="64" height="28" alt="logo">
        </div>
      </div>

      <div class="content" #pageContent>
        <!-- Primera página tiene contenido fijo -->
        <ng-container *ngIf="page.showStaticTop">
          <div class="static-section" #staticContentArea>
            <!-- Nueva sección de información -->
            <div class="info-section" *ngIf="client && groupedServices.length > 0">
              <div class="info-item">
                <div class="info-label">Proyecto:</div>
                <div class="info-value">
                  <span class="info-value-bold">{{ groupedServices[0].service.project?.name || '-' }}</span>
                  <span class="info-value-regular">{{ groupedServices[0].service.project?.reference || '-' }}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">Cliente:</div>
                <div class="info-value">
                  <span class="info-value-bold">{{ client.name || '-' }}</span>
                  <span class="info-value-regular">{{ client.vat || '-' }}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">Tipo de cambio:</div>
                <div class="info-value">
                  <span class="info-value-bold">{{ currentCurrency?.currentCurrencyExchange?.baseRate || '-' }}</span>
                  <span class="info-value-regular">({{ getCurrentDateFormatted() }})</span>
                </div>
              </div>
            </div>

            <!-- Valor del servicio-->
            <div class="invoice-container" style="box-sizing: border-box;">
            <!-- Tabla de valores -->
            <nz-descriptions nzBordered
                             [nzColumn]="2"
                             class="invoice-table custom-invoice-style">
              <!-- Fila 1 -->
              <nz-descriptions-item nzTitle="Valor del servicio" [nzSpan]="2" class="semibold">
                <span
                  class="text-semibold">{{ isNoDecimalCurrency() ? ((totalRow.amount + totalRow.totalIva)| number:'1.0-0') : ((totalRow.amount + totalRow.totalIva)| number:'1.0-2') }} {{ currentCurrency?.isoCode || '' }}</span>
              </nz-descriptions-item>

              <!-- Fila 2 -->
              <nz-descriptions-item nzTitle="Gastos reembolsables" [nzSpan]="2">
                {{ isNoDecimalCurrency() ? (order.reimbursableExpenses|number:'1.0-0') : (order.reimbursableExpenses|number:'1.0-2') }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 3 - I.V.A. -->
              <nz-descriptions-item nzTitle="I.V.A." [nzSpan]="2">
                {{ isNoDecimalCurrency() ? (totalRow.totalIva|number:'1.0-0') : (totalRow.totalIva|number:'1.0-2') }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 4 - Total -->
              <nz-descriptions-item nzTitle="Total" [nzSpan]="2">
                {{ isNoDecimalCurrency() ? ((totalRow.amount + totalRow.totalIva)|number:'1.0-0') : ((totalRow.amount + totalRow.totalIva)|number:'1.0-2') }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 5 -->
              <nz-descriptions-item nzTitle="Retención" [nzSpan]="2">
                {{ isNoDecimalCurrency() ? (order.retention|number:'1.0-0') : (order.retention|number:'1.0-2') }} {{ currentCurrency?.isoCode || '' }}
              </nz-descriptions-item>

              <!-- Fila 6 (Total a pagar) -->
              <nz-descriptions-item [nzSpan]="2"
                                    nzTitle="Total a pagar"
                                    class="semibold"
              >
                <span
                  class="text-semibold">{{ isNoDecimalCurrency() ? ((totalRow.amount + totalRow.totalIva + order.reimbursableExpenses + order.retention)| number:'1.0-0') : ((totalRow.amount + totalRow.totalIva + order.reimbursableExpenses + order.retention)| number:'1.0-2') }} {{ currentCurrency?.isoCode || '' }}</span>
              </nz-descriptions-item>
            </nz-descriptions>
            </div>
          </div>
        </ng-container>

        <!-- Contenido dinámico que fluye entre páginas -->
        <ng-container *ngIf="page.summary as summarySection">
          <!-- Resumen de distribucion del servicio-->
          <div class="factura-tabla" #summarySectionContainer>
              <span class="text-label-10 text-semibold color-grey-10 subTitle">Resumen distribución de servicio</span>
              <nz-table #summaryTable [nzShowPagination]="false" nzBordered [nzData]="summarySection.rows" [nzPageSize]="100">
                <thead>
                <tr>
                  <th>Identificación de costos</th>
                  <th nzAlign="right">Valor unitario</th>
                  <th nzAlign="right">I.V.A.</th>
                  <th nzAlign="right">Detalle</th>
                  <th *ngFor="let currencyColumn of dinamicCurrencyColumns" nzAlign="center">{{ currencyColumn.name }}
                  </th>
                  <th nzAlign="right">Monto</th>
                </tr>
                </thead>
                <tbody>
                  @for (group of summaryTable.data; track group.service.id; let rowIndex = $index) {
                    <tr>
                      <td>
                        <div class="service-name-container">
                          <div class="service-name-row">
                            <span class="service-index">{{ group.displayIndex ?? (rowIndex + 1) }}.</span>
                            <span class="service-name">{{ group.service.name }}</span>
                          </div>
                          <span class="service-operations">{{ group.service.customOperations || '' }}</span>
                        </div>
                      </td>
                      <td
                        nzAlign="right">{{
                          isNoDecimalCurrency() ?
                            (group.service.servicePricing?.unitPrice || group.service.servicePricing?.totalPrice | number:'1.0-0') :
                            (group.service.servicePricing?.unitPrice || group.service.servicePricing?.totalPrice | number:'1.0-2')
                        }}
                      </td>
                      @if (isInvoiceOrder) {
                        @if (group.service.servicePricing?.unitSaleVat != null) {
                          <td
                            nzAlign="right">{{
                              isNoDecimalCurrency() ?
                                (((group.service.servicePricing?.unitSaleVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-0') :
                                (((group.service.servicePricing?.unitSaleVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-2')
                            }}
                            ({{
                              isNoDecimalCurrency() ?
                                ((group.service.servicePricing?.unitSaleVat ?? 0) | number:'1.0-0') :
                                ((group.service.servicePricing?.unitSaleVat ?? 0) | number:'1.0-2')
                            }}%)
                          </td>
                        } @else {
                          <td
                            nzAlign="right">{{
                              isNoDecimalCurrency() ?
                                (((group.service.servicePricing?.totalSaleVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-0') :
                                (((group.service.servicePricing?.totalSaleVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-2')
                            }}
                            ({{
                              isNoDecimalCurrency() ?
                                ((group.service.servicePricing?.totalSaleVat ?? 0) | number:'1.0-0') :
                                ((group.service.servicePricing?.totalSaleVat ?? 0) | number:'1.0-2')
                            }}%)
                          </td>
                        }

                      } @else {
                        @if (group.service.servicePricing?.unitPurchaseVat != null) {
                          <td
                            nzAlign="right">{{
                              isNoDecimalCurrency() ?
                                (((group.service.servicePricing?.unitPurchaseVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-0') :
                                (((group.service.servicePricing?.unitPurchaseVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-2')
                            }}
                            ({{
                              isNoDecimalCurrency() ?
                                ((group.service.servicePricing?.unitPurchaseVat ?? 0) | number:'1.0-0') :
                                ((group.service.servicePricing?.unitPurchaseVat ?? 0) | number:'1.0-2')
                            }}%)
                          </td>
                        } @else {
                          <td
                            nzAlign="right">{{
                              isNoDecimalCurrency() ?
                                (((group.service.servicePricing?.totalPurchaseVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-0') :
                                (((group.service.servicePricing?.totalPurchaseVat ?? 0) * group.totalServiceAmount / 100) | number:'1.0-2')
                            }}
                            ({{
                              isNoDecimalCurrency() ?
                                ((group.service.servicePricing?.totalPurchaseVat ?? 0) | number:'1.0-0') :
                                ((group.service.servicePricing?.totalPurchaseVat ?? 0) | number:'1.0-2')
                            }}%)
                          </td>
                        }
                      }
                      <td nzAlign="right">{{ group.serviceOrders.length }}</td>
                      <td *ngFor="let currencyColumn of dinamicCurrencyColumns" nzAlign="center">
                        @if (isNoDecimalCurrency()) {
                          {{
                            group.serviceDinamicData['currency_' + currencyColumn.id]
                              ? (group.serviceDinamicData['currency_' + currencyColumn.id] | number: '1.0-0')
                              : '-'
                          }}
                        } @else {
                          {{
                            group.serviceDinamicData['currency_' + currencyColumn.id]
                              ? (group.serviceDinamicData['currency_' + currencyColumn.id] | number: '1.0-2')
                              : '-'
                          }}
                        }
                      </td>
                      <td nzAlign="right">
                        <b>{{
                            isNoDecimalCurrency() ?
                              ((group.totalServiceAmount + (group.totalServiceAmount * group.serviceIva / 100))  | number:'1.0-0') :
                              ((group.totalServiceAmount + (group.totalServiceAmount * group.serviceIva / 100))  | number:'1.0-2')
                          }}</b>
                      </td>
                    </tr>
                  }
                </tbody>
              </nz-table>

              <!-- Espacio de 4px -->
              <!--              <ng-container *ngIf="block.isLastChunk">-->
              <div style="height: 4px;margin:0;"></div>

              <table class="totals-table" style="display: inline-table" #summaryInlineTable *ngIf="summarySection.includeTotals">
                <tbody>
                <!-- Fila de totales (estática) -->
                <tr class="total-row">
                  <td style=" height: 22px; padding-left: 10px" class="text-semibold"><span>Totales</span></td>
                  <td class="text-semibold"><span>{{ totalRow.percent }}</span></td>
                  <td class="text-semibold"><span>{{
                      isNoDecimalCurrency() ?
                        (totalRow.totalIva | number:'1.0-0') : (totalRow.totalIva | number:'1.0-2')
                    }}</span></td>
                  <td class="text-semibold"><span>{{ totalRow.detail }}</span></td>
                  <td *ngFor="let currencyColumn of dinamicCurrencyColumns" nzAlign="center">
                    @if (isNoDecimalCurrency()) {
                      {{
                        totalRow.totalDinamicData['currency_' + currencyColumn.id]
                          ? (totalRow.totalDinamicData['currency_' + currencyColumn.id] | number: '1.0-0')
                          : '-'
                      }}
                    } @else {
                      {{
                        totalRow.totalDinamicData['currency_' + currencyColumn.id]
                          ? (totalRow.totalDinamicData['currency_' + currencyColumn.id] | number: '1.0-2')
                          : '-'
                      }}
                    }
                  </td>
                  <td class="text-semibold"><span>{{
                      isNoDecimalCurrency() ?
                        ((totalRow.amount + totalRow.totalIva)| number:'1.0-0') :
                        ((totalRow.amount + totalRow.totalIva)| number:'1.0-2')
                    }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
          </div>
        </ng-container>

        <ng-container *ngIf="page.operations as operationsSection">
          <!--      Detalles de operaciones-->
          <div class="factura-tabla servicio-tabla flex flex-column" #operationsSectionContainer style="gap:4px; ">
            <div style="height: 20px;"><span class="text-label-10 text-semibold color-grey-10 subTitle">Detalle operaciones</span>
            </div>
            <div *ngIf="operationsSection.includeTotalsSummary" #operationsSummaryRow style="height: 22px; display: flex; justify-content: space-between; padding: 0 12px;">
              <div>
                <span class="subtitle2Bold">{{ getTotalServiceOrders() }}&nbsp;</span>
                <span class="subtitle2">Órdenes de servicio</span>
              </div>
              <div>
                <span class="subtitle2">Total:&nbsp;</span>
                <span class="subtitle2Bold">{{ isNoDecimalCurrency() ?
                  (getTotalAmount() | number:'1.0-0'):
                  (getTotalAmount() | number:'1.0-2') }}&nbsp;{{ currentCurrency?.isoCode || '' }}</span>
              </div>
            </div>
            <nz-table #unifiedOperationsTable [nzData]="operationsSection.rows" [nzShowPagination]="false" nzBordered
                      [nzPageSize]="10000">
                <thead>
                <tr>
                  <th nzAlign="center">Servicio</th>
                  <th nzAlign="center">Motonave</th>
                  <th nzAlign="center">Contenedor</th>
                  <th nzAlign="center">Ref. CEC</th>
                  <th nzAlign="center">Cantidad</th>
                  <th nzAlign="center">Valor unitario</th>
                  <th nzAlign="center">Tipo de cambio</th>
                  <th nzAlign="center">Monto {{ currentCurrency?.isoCode || '' }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of unifiedOperationsTable.data">
                  <td nzAlign="center">{{ data.service.name }}</td>
                  <td nzAlign="center">{{ data.serviceOrder.motonave?.name }}</td>
                  <td nzAlign="center">{{ data.serviceOrder.projectContainer?.containerRef }}</td>
                  <td nzAlign="center">{{ data.serviceOrder.referenceCEC }}</td>
                  <td nzAlign="center">{{ data.service.servicePricing?.unitQuantity || data.service.servicePricing?.totalQuantity || 1 }}</td>
                  <td nzAlign="center">{{ isNoDecimalCurrency() ?
                    (data.service.servicePricing?.unitPrice || data.service.servicePricing?.totalPrice | number:'1.0-0') :
                    (data.service.servicePricing?.unitPrice || data.service.servicePricing?.totalPrice | number:'1.0-2') }}</td>
                  <td nzAlign="center">{{ currentCurrency?.currentCurrencyExchange?.baseRate || '-' }}</td>
                  <td nzAlign="center"><span>{{
                      isNoDecimalCurrency() ?
                        (data.totalAmount | number: '1.0-0') :
                        (data.totalAmount | number: '1.0-2')
                    }}</span></td>
                </tr>
                </tbody>
              </nz-table>
          </div>
        </ng-container>

        <div class="signature-section" #signatureSection *ngIf="page.showSignature">
          <div style="height: 20px;"><span class="text-label-10 text-semibold color-grey-10 subTitle">Ruta de firmas</span></div>
          <div style="padding: 12px; background-color: #FAFAFA; border-radius: 6px; height: 75px;">
            <nz-row class="signature-header">
              <nz-col nzSpan="6">Emitido por</nz-col>
              <nz-col nzSpan="6">Revisado por</nz-col>
              <nz-col nzSpan="6">Enviado por</nz-col>
              <nz-col nzSpan="6">Aprobado por</nz-col>
            </nz-row>

            <!-- Fila de datos -->
            <nz-row class="signature-data">
              <!-- Emitido por -->
              <nz-col nzSpan="6" class="signature-col">
                <div class="signature-name">
                  <span>{{ order.transmitter?.name || '-' }} {{ order.transmitter?.surName }}</span></div>
                <div class="signature-area">{{ order.transmitter?.position || '-' }}</div>
                <div class="signature-entity">{{ order.transmitter?.parentPartner?.name }}</div>
              </nz-col>

              <!-- Revisado por -->
              <nz-col nzSpan="6" class="signature-col">
                <div class="signature-name">
                  <span>{{ order.revision?.name || '-' }} {{ order.revision?.surName }}</span></div>
                <div class="signature-area">{{ order.revision?.position || '-' }}</div>
                <div class="signature-entity">{{ order.revision?.parentPartner?.name }}</div>
              </nz-col>

              <!-- Enviado por -->
              <nz-col nzSpan="6" class="signature-col">
                <div class="signature-name">
                  <span>{{ order.shipper?.name || '-' }} {{ order.shipper?.surName }}</span></div>
                <div class="signature-area">{{ order.shipper?.position || '-' }}</div>
                <div class="signature-entity">{{ order.shipper?.parentPartner?.name }}</div>
              </nz-col>

              <!-- Aprobado por -->
              <nz-col nzSpan="6" class="signature-col">
                <div class="signature-name">
                  <span>{{ order.approver?.name || '-' }} {{ order.approver?.surName }}</span></div>
                <div class="signature-area"><span>{{ order.approver?.position || '-' }}</span></div>
                <div class="signature-entity">{{ order.approver?.parentPartner?.name }}</div>
              </nz-col>
            </nz-row>
          </div>
        </div>
      </div>

      <div class="footer" #pageFooter>
        <div class="footer-note">Nota: El plazo máximo para enviar observaciones del EP es de 48 hrs, por lo que, pasado este plazo se procederá con la facturación sin derecho a nota de crédito o modificación en la factura.</div>
        <div class="page-number">Página {{ i + 1 }}/{{ pages.length }}</div>
      </div>
    </div>
    <div *ngIf="!last" class="page-break"></div>
  }

  <div class="pdf-ready"
       *ngIf="isPdfReady"
       style="display: none">
  </div>

</div>
